import type { TolgeeInstance } from '@tolgee/web'
import type { i18n } from 'i18next'
import { tolgeePreProcessor } from '../preProcessor'

const isDefined = <T>(value: T | undefined): value is T => value !== undefined

export const tolgeeApply = (tolgee: TolgeeInstance, i18n: i18n) => {
  const updateTranslations = () => {
    tolgee
      .getAllRecords()
      .filter(isDefined)
      .forEach(({ language, namespace, data }) => {
        if (i18n.getResourceBundle(language, namespace)) {
          i18n.addResourceBundle(language, namespace, tolgeePreProcessor(data), false, true)
        }
      })
  }

  tolgee.on('update', updateTranslations)
  i18n.on('languageChanged', (lang) => {
    if (lang && tolgee.getLanguage() !== lang) {
      tolgee.changeLanguage(lang)
    }
  })

  i18n.tolgee = tolgee
}

declare module 'i18next' {
  interface i18n {
    tolgee: TolgeeInstance
  }

  interface TOptionsBase {
    /**
     * Omit tolgee wrapper
     */
    noWrap?: boolean
  }
}
